import { CIRCLES } from '../../constants/strings';

export const getFamilyMemberRole = (
  { caregiver, guardian, proxy, parent },
  formatMessage,
) => {
  const roleList = [];
  if (caregiver) roleList.push(formatMessage(CIRCLES.titles.caregiverRole));
  if (guardian) roleList.push(formatMessage(CIRCLES.titles.guardianRole));
  if (proxy) roleList.push(formatMessage(CIRCLES.titles.proxyRole));
  if (parent) roleList.push(formatMessage(CIRCLES.titles.parentRole));
  return roleList.filter(Boolean).join(', ');
};



// WEBPACK FOOTER //
// ./src/utils/converters/getFamilyMemberRole.js